import {
  PAYOFF_COUPON_CAP,
  PAYOFF_COUPON_FLOOR,
  PAYOFF_COUPON_SPREAD,
} from './product-capture-field-selectors.consts';

export const PAYOFF_COUPON_SPREAD_CAP_FLOOR_GROUP = [
  PAYOFF_COUPON_SPREAD,
  PAYOFF_COUPON_CAP,
  PAYOFF_COUPON_FLOOR,
];
